export default {
  "home.heading.default": "entra in call",
  "home.heading.loading": "Apro la stanza...",
  "home.heading.join": "pronto a entrare?",
  "home.heading.joined": "sei dentro",
  "home.heading.pending": "aspettando l'host",
  "home.body.default": "crea una stanza, gira il link, chill.",
  "home.body.loading": "un sec, preparo la stanza.",
  "home.body.join": "check a cam e mic, poi buttati.",
  "home.body.joined": "la stanza è live. gira il link o inizia.",
  "home.body.joined_in_room": "nella stanza — buttati o gira il link.",
  "home.body.pending": "la stanza è chiusa. l'host ti farà entrare.",
  "home.cta.create": "Crea stanza",
  "home.cta.join": "Entra",
  "home.cta.enter": "Entra nella stanza",
  "home.cta.creating": "Sto creando...",
  "home.cta.joining": "Entrando...",
  "home.cta.opening": "Aprendo...",
  "home.cta.pending": "In attesa dell'ok...",
  "home.copy_link": "copia link",
  "home.copied": "copiato!",
  "home.leave": "esci dalla stanza",
  "home.back": "indietro",
  "home.no_participants": "ancora nessuno qui",
  "home.join_by_code": "entra con codice",
  "home.code_placeholder": "inserisci codice",
  "home.name_placeholder": "il tuo nome",
  "home.people_one": "persona",
  "home.people_other": "persone",
  "home.marketing.invite.title": "Crea una stanza,\ncondividi il link.",
  "home.marketing.invite.body": "Basta un tap. Gira il link agli amici e chiunque può entrare — zero download, zero registrazioni.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Appari come\nvuoi tu.",
  "home.marketing.look.body": "Color grading, filtri soft, vignettatura — o sfoca del tutto la faccia. La tua cam, il tuo stile.",
  "home.marketing.host.title": "Il tuo spazio,\nle tue regole.",
  "home.marketing.host.body": "Chiudi la stanza, muta qualcuno o buttalo fuori. L'host ha il controllo totale.",
  "home.marketing.host.locked": "Stanza chiusa",
  "home.marketing.host.waiting_to_join": "In attesa di entrare",
  "home.marketing.host.wants_to_join": "vuole entrare",
  "home.marketing.anything.title": "Per qualsiasi cosa, davvero.",
  "home.marketing.anything.body": "Gruppi studio, serate gaming, standup di lavoro, watch party — o giusto per chillare.",
  "home.marketing.use_case.study_group": "📚 gruppo studio",
  "home.marketing.use_case.game_night": "🎮 serata gaming",
  "home.marketing.use_case.standup": "💼 standup",
  "home.marketing.use_case.watch_party": "🍿 watch party",
  "home.marketing.use_case.catch_up": "☕ chiacchierata",
  "home.marketing.use_case.jam_session": "🎸 jam session",
  "home.marketing.use_case.book_club": "📖 club del libro",
  "home.marketing.use_case.coworking": "💻 co-working",
  "ended.heading": "call finita",
  "ended.left": "sei uscito dalla stanza.",
  "ended.room_ended": "{title} è finita per te.",
  "ended.rejoin": "rientra",
  "ended.rejoining": "rientrando...",
  "ended.home": "torna alla home",
  "call.connecting": "connessione...",
  "call.waiting": "in attesa degli altri",
  "call.invite_code": "codice invito",
  "call.audio_on": "audio on",
  "call.muted": "mutato",
  "call.listening": "In ascolto",
  "call.audio_muted": "Audio mutato",
  "call.speaking": "sta parlando",
  "call.you": "tu",
  "call.you_label": "Tu",
  "call.you_suffix": "(tu)",
  "call.chat_placeholder": "scrivi un messaggio...",
  "call.guest": "ospite",
  "call.room_fallback": "stanza",
  "call.focus_view": "Vista focus",
  "call.grid_view": "Vista griglia",
  "call.swap_main_video": "Cambia video principale",
  "call.open_chat": "Apri chat",
  "call.close_chat": "Chiudi chat",
  "call.leave_room": "Esci dalla stanza",
  "call.confirm_leave": "Uscire?",
  "call.mic_on": "Mic on",
  "call.muted_label": "Mutato",
  "call.camera_off": "Cam off",
  "call.connect_failed": "Connessione fallita — checka internet e riprova.",
  "call.camera_access_failed": "Impossibile accedere alla cam. Controlla i permessi del browser e riprova.",
  "call.recording_failed": "Impossibile avviare la registrazione. La call andrà avanti senza.",
  "call.initialize_failed": "Qualcosa è andato storto nell'avviare la call. Ricarica la pagina e riprova.",
  "call.participants": "Partecipanti",
  "call.open_participants": "Apri partecipanti",
  "call.close_participants": "Chiudi partecipanti",
  "call.lock_room": "Chiudi stanza",
  "call.unlock_room": "Apri stanza",
  "call.locked": "chiusa",
  "call.unlocked": "aperta",
  "call.kick_member": "Rimuovi dalla stanza",
  "call.mute_member": "Muta",
  "call.unmute_member": "Smuta",
  "call.muted_by_host": "Mutato dall'host",
  "call.waiting_to_join": "In attesa di entrare",
  "call.approve": "Approva",
  "call.deny": "Rifiuta",
  "call.profile_actions": "Azioni profilo",
  "call.profile_in_room": "Nella stanza",
  "call.profile_role_host": "Host",
  "call.profile_role_you": "Tu",
  "call.profile_action_mute": "Muta il suo audio",
  "call.profile_action_mute_meta": "Solo per te — non lo saprà",
  "call.profile_action_dm": "DM 1:1",
  "call.profile_action_dm_meta": "Inizia una chat privata",
  "call.profile_action_view": "Vedi profilo completo",
  "call.profile_action_view_meta": "Bio, lingue, sessioni passate",
  "call.profile_action_report": "Segnala",
  "call.profile_action_report_meta": "Segnala ai moderatori",
  "call.profile_sheet_close": "Chiudi azioni profilo",
  "call.profile_open_actions": "Apri azioni profilo",
  "call.dm_title": "Messaggio diretto",
  "call.dm_back": "Torna alle azioni",
  "call.dm_close": "Chiudi messaggio diretto",
  "call.dm_status_online": "Online",
  "call.dm_in_room_with": "In questa stanza",
  "call.dm_private_label": "Chat privata",
  "call.dm_private_meta": "Solo voi due potete vedere questi messaggi",
  "call.dm_input_placeholder": "Manda un messaggio privato…",
  "call.dm_send": "Invia",
  "call.dm_just_now": "ora",
  "call.dm_seen_just_now": "Visto ora",
  "call.dm_typing": "{name} sta scrivendo…",
  "call.dm_minimize": "Riduci",
  "call.dm_active_indicator": "Apri conversazione",
  "call.dm_unread_messages": "{count} non letti",
  "call.dm_toast_tap_to_open": "Tocca per aprire",
  "call.dm_reopen_aria": "Riapri conversazione con {name}",
  "home.join_denied": "L'host non ti ha fatto entrare.",
  "home.error.room_not_found": "Questo codice stanza non esiste.",
  "home.error.profile_required": "Imposta il tuo profilo per continuare.",
  "home.cta.set_up_profile": "Imposta il tuo profilo",
  "home.profile_trigger_new": "Tocca per aggiungere i tuoi dettagli",
  "home.profile_trigger_new_aria": "Imposta il tuo profilo",
  "home.profile_trigger_edit_aria": "Modifica il tuo profilo",
  "profile.eyebrow_new": "saluta",
  "profile.eyebrow_edit": "il tuo profilo",
  "profile.title_new": "Fallo tuo.",
  "profile.title_edit": "Modifica profilo",
  "profile.subtitle": "Qualche info al volo per far sapere agli altri con chi stanno parlando.",
  "profile.add_photo": "Aggiungi foto",
  "profile.add_photo_soon": "foto in arrivo",
  "profile.photo_empty": "tocca per aggiungere una foto",
  "profile.photo_ready": "foto pronta",
  "profile.photo_save_first": "salva il profilo prima di caricare una foto",
  "profile.photo_crop_caption": "inquadra la foto",
  "profile.photo_auto_caption": "trascina e zooma, poi salviamo in automatico",
  "profile.photo_upload": "Carica foto",
  "profile.photo_replace": "Cambia foto",
  "profile.photo_remove": "Rimuovi foto",
  "profile.photo_cancel": "Annulla",
  "profile.photo_save": "Salva foto",
  "profile.photo_uploading": "Caricamento foto…",
  "profile.photo_removing": "Rimozione foto…",
  "profile.photo_choose_another": "Scegli un'altra",
  "profile.photo_drag_hint": "Trascina la foto per centrarla nel cerchio. Si salva in automatico.",
  "profile.photo_zoom": "Zoom",
  "profile.photo_horizontal": "Ritaglio orizzontale",
  "profile.photo_vertical": "Ritaglio verticale",
  "profile.name_label": "Nome",
  "profile.name_placeholder": "Come ti chiamiamo?",
  "profile.gender_label": "Sono",
  "profile.gender.woman": "Donna",
  "profile.gender.man": "Uomo",
  "profile.gender.unspecified": "Preferisco non dirlo",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "opzionale",
  "profile.bio_placeholder": "Lingue che parli, cosa ti piace, qualsiasi cosa…",
  "profile.cta_new": "Andiamo",
  "profile.cta_edit": "Salva modifiche",
  "profile.saving": "Salvataggio…",
  "profile.close": "Chiudi",
  "profile.error.save_failed": "Impossibile salvare il profilo. Riprova.",
  "profile.error.avatar_invalid_type": "Scegli un'immagine PNG, JPEG, GIF o WebP.",
  "profile.error.avatar_too_large": "Scegli un'immagine più piccola di 5 MB.",
  "profile.error.avatar_too_small": "Scegli un'immagine di almeno 96x96 pixel.",
  "profile.error.avatar_load_failed": "Non riusciamo a leggere l'immagine. Prova un altro file.",
  "profile.error.avatar_failed": "Impossibile caricare la foto. Riprova.",
  "profile.error.avatar_remove_failed": "Impossibile rimuovere la foto. Riprova.",
  "effects.title": "Effetti",
  "effects.soft": "Soft focus",
  "effects.vignette": "Vignettatura",
  "effects.face": "Sfoca viso",
  "effects.face_preview_only": "Sfoca viso (solo anteprima)",
  "effects.face_viewer_side": "Sfoca viso (lato spettatore)",
  "effects.face_strength": "Intensità sfocatura viso",
  "effects.grade.off": "OFF",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "WARM",
  "effects.grade.cool": "COOL",
  "effects.grade.bw": "B&W",
  "camera.off": "la cam è spenta",
  "camera.check": "checka la cam",
  "camera.retry": "riprova cam",
  "camera.ready": "cam pronta",
  "camera.idle.title": "Accendi la cam",
  "camera.idle.hint": "Chiederemo l'accesso al browser quando ci sei.",
  "camera.idle.button": "Accendi cam",
  "camera.status.idle": "Ti stiamo aspettando",
  "camera.status.off": "La cam è spenta",
  "camera.status.loading": "Richiesta accesso alla cam...",
  "camera.status.denied": "Consenti l'accesso alla cam nel browser, poi riprova.",
  "camera.status.error": "Anteprima cam fallita. Riprova.",
  "camera.status.unsupported": "Questo browser non supporta l'accesso alla cam.",
  "camera.status.insecure": "L'accesso alla cam richiede HTTPS o localhost.",
  "camera.status.attach_failed": "Impossibile avviare l'anteprima della cam. Riprova.",
  "camera.guest_name_placeholder": "Nome ospite",
  "camera.flip": "Gira cam",
  "camera.save_name": "Salva",
  "camera.edit_name": "Modifica nome",
  "mic.on": "Spegni microfono",
  "mic.off": "Accendi microfono",
  "video.on": "Spegni cam",
  "video.off": "Accendi cam",
  "chat.title": "chat",
  "chat.close": "Chiudi chat",
  "chat.loading": "caricamento...",
  "chat.load_earlier": "carica precedenti",
  "chat.empty": "ancora nessun messaggio",
  "chat.send_error": "Messaggio non inviato — riprova.",
  "chat.input_placeholder": "scrivi un messaggio...",
  "room.host": "Host",
  "app.room_default_title": "Crea una stanza",
  "app.chat_connection_rejected": "Impossibile connettere la chat — prova a ricaricare.",
  "app.copy_failed": "Impossibile copiare il link. Prova a selezionarlo e copiarlo a mano.",
  "app.chat_not_connected": "La chat non è ancora connessa. Aspetta un attimo e riprova.",
  "footer.terms": "Termini & Condizioni",
  "footer.copyright": "© 2026 Yano.AI"
}
